import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickAddConstColumn from '@/components/brick_add_const_column.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-circle', 'text-orange']
infos.front_classes = ['fas', 'fa-dice-one', 'text-white']
infos.name = 'addconst'
infos.associated_class_name = 'AutomlAddConstColumn'
infos.editing_component_name = 'BrickAddConstColumn'
infos.editing_component = BrickAddConstColumn
infos.descriptions = {
	en: {
		short_tooltip_description: 'Const column',
		full_tooltip_description: 'Adds a constant column',
		navbar_name: 'Const column',
	},
	fr: {
		short_tooltip_description: 'Colonne constante',
		full_tooltip_description: 'Ajoute une colonne constante',
		navbar_name: 'Colonne constante',
	},
}
// infos.short_tooltip_description = 'addconst_short_tooltip'
// infos.full_tooltip_description = 'addconst_full_tooltip'
// infos.navbar_name = 'addconst_navbar'
infos.background_color = 'orange'

brick_registerer(infos)
